import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './pages.css';

const MagicLinkVerifyPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loadUserGroups } = useAuth();
  const [isVerifying, setIsVerifying] = useState(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const handleVerificationResult = async () => {
      const loginSuccess = searchParams.get('login');
      const errorParam = searchParams.get('error');
      
      if (loginSuccess === 'success') {
        // Magic link verification was successful, reload user groups
        try {
          await loadUserGroups();
          // The backend should have redirected us appropriately, but if we're here
          // it means we need to check the current URL for group context
          const currentPath = window.location.pathname;
          if (currentPath.includes('/group-selection')) {
            // Multi-group user, stay on group selection page
            navigate('/group-selection', { replace: true });
          } else {
            // Single group user, should have been redirected to dashboard
            // If we're still here, something went wrong
            setError('Errore durante il reindirizzamento');
            setIsVerifying(false);
          }
        } catch (error) {
          console.error('Failed to load user groups after verification:', error);
          setError('Errore durante il caricamento dei gruppi');
          setIsVerifying(false);
        }
      } else if (errorParam) {
        // Handle specific error cases
        switch (errorParam) {
          case 'invalid_token':
            setError('Link di accesso non valido o scaduto');
            break;
          default:
            setError('Errore durante la verifica del link');
        }
        setIsVerifying(false);
      } else {
        // This page should not be reached in normal flow since backend redirects
        // If we're here without parameters, it means there was an error
        setError('Link di accesso non valido o scaduto');
        setIsVerifying(false);
      }
    };

    handleVerificationResult();
  }, [searchParams, loadUserGroups, navigate]);



  if (isVerifying) {
    return (
      <div className="verify-page">
        <div className="verify-container">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Verifica del link di accesso in corso...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="verify-page">
        <div className="verify-container">
          <div className="error-container">
            <div className="error-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
            </div>
            <h2>Errore di verifica</h2>
            <p>{error}</p>
            <div className="actions">
              <button 
                onClick={() => navigate('/login')}
                className="back-to-login-button"
              >
                Torna al login
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }



  return (
    <div className="verify-page">
      <div className="verify-container">
        <p>Reindirizzamento in corso...</p>
      </div>
    </div>
  );
};

export default MagicLinkVerifyPage;